import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TeamWorkingIllustration from 'svg/illustrations/TeamWorking';

const valueItems = [
  {
    title: 'Reducir errores manuales',
    description: 'Automatización del registro y clasificación de egresos.',
  },
  {
    title: 'Visibilidad clara',
    description: 'Conocer el gasto real del negocio en tiempo real.',
  },
  {
    title: 'Decisiones basadas en datos',
    description: 'Información actualizada para una mejor toma de decisiones.',
  },
  {
    title: 'Adaptación cambiaria',
    description: 'Sistema preparado para variaciones del tipo de cambio BCV.',
  },
];

const ValorSection = () => (
  <Box>
    <Typography
      sx={{ textTransform: 'uppercase', fontWeight: 600 }}
      gutterBottom
      color="primary"
      align="center"
    >
      Valor del sistema
    </Typography>
    <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
      Este sistema permitirá
    </Typography>
    <Grid container spacing={4} alignItems="center" sx={{ mt: 2 }}>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          {valueItems.map((item, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Box
                component={Card}
                variant="outlined"
                sx={{
                  height: '100%',
                  transition: 'all .2s ease-in-out',
                  '&:hover': { transform: 'translateY(-4px)', boxShadow: 2 },
                }}
              >
                <CardContent>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
        <Box maxWidth={400} width="100%">
          <TeamWorkingIllustration height="100%" width="100%" />
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default ValorSection;
